import { useContext, useEffect, useRef, useState } from 'react'
import TileV2Header from '../../TileV2Header'
import {
  MentorCardPortraitCardsContainer,
  MentorPortraitCardActionButton,
  MentorPortraitCardContainer,
  MentorPortraitCardPicture,
  MentorPortraitCardText,
} from './mentorCardPortraitStyles'
import {
  HorizontalScrollLeftButton,
  HorizontalScrollRightButton,
} from 'src/consumer/components/CardList/CardListStyle'
import { Link } from 'react-router-dom'
import { getDisplayEventTypesOfMentor } from 'src/consumer/components/Professionals List Page'

const CardListComponent = ({ items = [], ...restProps }) => {
  return items?.map((item, index) => {
    return <MentorCardPortraitSingleCard key={index} item={item} {...restProps} />
  })
}

export default function MentorCardPortraitTileComponent({
  headingLogicAndData,
  areTileItemsHovered,
  logicAndData,
}) {
  return (
    <>
      <TileV2Header
        logicAndData={{
          ...headingLogicAndData,
          isOnBackground: headingLogicAndData?.isOnBackground,
        }}
      />
      <MentorCardPortraitCarouselComponent
        areTileItemsHovered={areTileItemsHovered}
        logicAndData={logicAndData}
      />
    </>
  )
}

export function MentorCardPortraitCarouselComponent({ areTileItemsHovered, logicAndData }) {
  const cardRef = useRef()
  const [leftButtonVisible, setLeftButtonVisible] = useState(false)
  const [rightButtonVisible, setRightButtonVisible] = useState(false)
  const handleScrollLeft = () => {
    if (cardRef.current) {
      const containerWidth = cardRef.current.offsetWidth
      const scrollDistance = containerWidth * 0.75
      cardRef.current.scrollLeft -= scrollDistance // adjust the scroll distance as needed
    }
  }
  const handleScrollRight = () => {
    if (cardRef.current) {
      const containerWidth = cardRef.current.offsetWidth
      const scrollDistance = containerWidth * 0.75
      cardRef.current.scrollLeft += scrollDistance // adjust the scroll distance as needed
    }
  }
  const handleScroll = (event) => {
    const container = event.target
    const scrollPosition = container.scrollLeft
    const maxScrollLeft = container.scrollWidth - container.clientWidth
    const reachedLeftEnd = scrollPosition === 0
    const reachedRightEnd = scrollPosition === maxScrollLeft
    setLeftButtonVisible(!reachedLeftEnd)
    setRightButtonVisible(!reachedRightEnd)
  }
  useEffect(() => {
    const container = cardRef.current
    const scrollPosition = container.scrollLeft
    const maxScrollLeft = container.scrollWidth - container.clientWidth
    const reachedLeftEnd = scrollPosition === 0
    const reachedRightEnd = scrollPosition === maxScrollLeft
    setLeftButtonVisible(!reachedLeftEnd)
    setRightButtonVisible(!reachedRightEnd)
  }, [])
  return (
    <MentorCardPortraitCardsContainer ref={cardRef} onScroll={handleScroll}>
      {areTileItemsHovered && leftButtonVisible && (
        <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
      )}

      <CardListComponent {...logicAndData} />

      {areTileItemsHovered && rightButtonVisible && (
        <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
      )}
    </MentorCardPortraitCardsContainer>
  )
}

export const MentorCardPortraitSingleCard = ({
  item,
  getTitleField,
  getMainImage,
  getSecondaryText,
  getTertiaryText,
  getPrimarySpecialText,
  getSecondarySpecialText,
  getTertiarySpecialText,
  getActionButtonLogic,
  getSecondaryActionButtonLogic,
}) => {
  useEffect(() => {
    console.log({ item })
  }, [item])

  const displayEventTypes = getDisplayEventTypesOfMentor(item)?.find((item) => !item?.free)?.uid

  return (
    <MentorPortraitCardContainer className="_mentor-card-portrait-single-card-container_">
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          textAlign: 'center',
        }}
      >
        <MentorPortraitCardPicture src={getMainImage(item)} alt='MentorPortraitImg' />
        <div>
          <MentorPortraitCardText main>{getTitleField(item)}</MentorPortraitCardText>
          <MentorPortraitCardText>{getSecondaryText(item)}</MentorPortraitCardText>
          <MentorPortraitCardText>{getTertiaryText(item)}</MentorPortraitCardText>
          {/* primarycomponent */}
          {/* secondarycomponent */}
          {/* tertiary compoentn */}
        </div>
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Link
          to={`/mentor/${item?.slug}/events/${displayEventTypes}`}
          style={{ textDecoration: 'none' }}
        >
          <MentorPortraitCardActionButton desiredClick>
            {getActionButtonLogic(item).text}
          </MentorPortraitCardActionButton>
        </Link>
        <Link to={`/mentor/${item?.slug}/events`} style={{ textDecoration: 'none' }}>
          <MentorPortraitCardActionButton>
            {getSecondaryActionButtonLogic(item).text}
          </MentorPortraitCardActionButton>
        </Link>
      </div>
    </MentorPortraitCardContainer>
  )
}
